import React from "react"
import styles from "./FreelancerProfileSidebar.module.scss"
import UserImage from "../UserImage/UserImage"
import ReportButton from "../ReportButton/ReportButton"

const formatEarnings = (v) => {
  if (v == null) return "—"
  if (typeof v === "number") {
    if (v >= 100000) return "$100K+"
    if (v >= 1000) return `$${(v / 1000).toFixed(0)}K`
    return `$${v}`
  }
  return String(v)
}

const formatNumber = (v) => (v != null ? String(v) : "—")
const formatWholeNumber = (v) =>
  v != null ? String(Math.round(Number(v))) : "—"

const FreelancerProfileSidebar = ({
  data,
  onReport,
  reported,
  userRole,
  onBlock,
  isBlocked,
}) => {
  const name = data?.name ?? "—"
  const title = data?.title ?? "—"
  const totalEarnings = data?.total_earnings
  const totalJobs = data?.total_jobs
  const totalHours = data?.total_hours
  const hoursPerWeek = data?.hours_per_week
  const languages = data?.languages ?? []

  return (
    <div className={styles.sidebar}>
      <ReportButton
        onReport={onReport}
        reported={reported}
        userRole={userRole}
        onBlock={onBlock}
        isBlocked={isBlocked}
        className={styles.reportIcon}
      />
      <div className={styles.imageContainer}>
        <UserImage image={data?.photo} selectedUser />
      </div>
      <h4 className={styles.name}>{name}</h4>
      <h6 className={styles.position}>{title}</h6>

      <div className={styles.statsRow}>
        <div className={styles.stat}>
          <span className={styles.statValue}>
            {formatEarnings(totalEarnings)}
          </span>
          <span className={styles.statLabel}>Total earnings</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.statValue}>{formatNumber(totalJobs)}</span>
          <span className={styles.statLabel}>Total jobs</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.statValue}>
            {formatWholeNumber(totalHours)}
          </span>
          <span className={styles.statLabel}>Total hours</span>
        </div>
      </div>

      <div className={styles.section}>
        <h6 className={styles.sectionTitle}>Hours Per Week</h6>
        <div className={styles.sectionValueWrap}>
          {hoursPerWeek && String(hoursPerWeek).trim() ? (
            String(hoursPerWeek)
              .split("\n")
              .map((line, i) => (
                <p key={i} className={styles.sectionValue}>
                  {line.trim()}
                </p>
              ))
          ) : (
            <p className={styles.sectionValue}>—</p>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <h6 className={styles.sectionTitle}>Languages</h6>
        <p className={styles.sectionValue}>
          {languages.length ? languages.join(", ") : "—"}
        </p>
      </div>
    </div>
  )
}

export default FreelancerProfileSidebar
